import Model from './model.js';
import Admin from './admin.js';
import GeoInfo from './geo_info';

export default class Log extends Model
{
    constructor(log){
        super()
        this.id         = 0
        this.ip_address = null
        this.user_agent = null
        this.date       = null
        this.user       = {}

        this.map(log)
        this.init()
    }

    map(log){
        if(log == undefined) return
        this.id         = log.id
        this.ip_address = log.ip_address
        this.user_agent = log.user_agent
        this.date       = log.date
        this.user       = new Admin(
            log.user.id,
            log.user.name,
            log.user.description,
            log.user.username,
            [], //permissions
            log.user.active,
            null,//password
            null,//confirm_password
            log.user.created_at
        ),
        this.geo_info = new GeoInfo(
            log.geo_info
        );
    }
}